import React from "react";
import { Icon, Popover, Position } from "@blueprintjs/core";
import CustomIcon from "../../components/CustomIcon";

export default function HomeCollectionsTab({ collections, selected, onTabClick }) {
  const collections_in_tabs =
    collections.length > 3 ? collections.slice(0, 3) : collections.slice(0, collections.length);
  const collections_in_popover = collections.length > 3 ? collections.slice(3, collections.length) : [];
  const tabExtenderMenu = (
    <ul className="bp3-menu">
      {collections_in_popover.map((collection, idx) => (
        <li className="menu-item-container" key={idx}>
          <a className="bp3-menu-item" onClick={(e) => onTabClick(collection.key)}>
            <CustomIcon name={collection.icon} className="icon" size="24" />
            {collection.name}
          </a>
        </li>
      ))}
    </ul>
  );
  return (
    <section className="tab-section">
      <div className="main-container">
        <div className="tabs landing-tabs">
          {collections_in_tabs.map((collection, idx) => {
            const selectedClass = collection.key === selected ? "selected" : "";
            return (
              <div onClick={(_) => onTabClick(collection.key)} key={idx} className={`tab ${selectedClass}`}>
                <CustomIcon name={collection.icon} className="icon" size="24" />
                <strong>{collection.name}</strong>
              </div>
            );
          })}

          <Popover content={tabExtenderMenu} position={Position.BOTTOM}>
            <div className="tab extender">
              <Icon icon="more" iconSize="18" />
            </div>
          </Popover>
        </div>
      </div>
    </section>
  );
}
